// ==================== ORGANIZATIONS CONTEXT DEFINITION ====================

import { createContext } from 'react';
import type { Organization } from '../../services/organizations.service';

// ==================== TYPES ====================

export interface OrganizationsContextType {
  /** The customer's organizations (shown as accounts), primary first. Empty for sub-accounts and admins */
  organizations: Organization[];
  /** Organizations paid for */
  purchased: number;
  /** Organizations added so far */
  created: number;
  /** More than one: the header dropdown and the per-organization behaviour apply */
  isMultiOrganization: boolean;
  loading: boolean;
  refetch: () => Promise<void>;
  /** The organization chosen in the header dropdown; undefined = all of them */
  selectedOrganizationId: string | undefined;
  selectOrganization: (organizationId: string | undefined) => void;
  /**
   * Call before creating something: with several organizations and "All Accounts" chosen it
   * raises the notice asking for a specific account and returns false (nothing is created)
   */
  requireAccount: (action: string) => boolean;
  /** The notice raised by requireAccount, shown under the header */
  accountNotice: string | null;
  dismissAccountNotice: () => void;
}

// ==================== CONTEXT ====================

export const OrganizationsContext = createContext<OrganizationsContextType | undefined>(undefined);
